import { EpimsBaseEntityDto } from './epim-base.dto';

export class CorrespondenceCommunityDto extends EpimsBaseEntityDto {
  RegisterId: string;
  CorrespondenceCommunityName: string;
  ImpactedState: string;
  ImpactedLGA: string;
  StateId: string;
  LgaId: string;
  CommunityId: string;
  Remarks: string;
}
